import { Button, type ButtonProps } from "@mui/material";

export default function TextButton({ sx, ...props }: ButtonProps) {
  return (
    <Button
      variant="text"
      disableRipple
      sx={{
        color: "text.accent",
        textDecoration: "underline",
        minWidth: "auto",
        background: "transparent",
        p: 0,
        "&:hover": { backgroundColor: "transparent" },
        ...sx,
      }}
      {...props}
    />
  );
}
